/**
 * Essay content validator
 * Validates essay data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import { tiptapJsonToPlainText, isTiptapDocument } from '@ai-content-hub/content-kit';
import type { EssayData } from './schema';

export const essayValidator: ContentValidator<EssayData> = {
    validate(data: EssayData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        const q = data?.essayQuestion?.question;
        const questionEmpty = (() => {
            if (q && typeof q === 'object' && isTiptapDocument(q)) {
                return !tiptapJsonToPlainText(q).trim();
            }
            if (typeof q === 'string') {
                return !q.trim();
            }
            return true;
        })();

        if (questionEmpty) {
            errors.push({
                field: 'essayQuestion.question',
                message: 'Essay question is required.',
                // EAA-2070: i18n key in defaultEssayI18n — the editor shows it translated.
                code: 'essayQuestionRequired',
            });
        }

        const minWords = data?.essayQuestion?.minWords ?? 0;
        const maxWords = data?.essayQuestion?.maxWords ?? 0;
        if (minWords > 0 && maxWords > 0 && minWords > maxWords) {
            errors.push({
                field: 'essayQuestion.maxWords',
                message: 'Maximum words must be greater than or equal to minimum words.',
                code: 'essayMaxWordsBelowMin',
            });
        }

        return { isValid: errors.length === 0, errors };
    },
};
